<template>
    <div class="card--container">
        <div class="card-header">
            <div class="card-header--content">
                <img class="app-icon" v-lazy="app.icon" />
                {{app.name}}
            </div>
        </div>
        <div class="van-hairline--bottom"></div>
        <div class="card-body">
            <div v-html="app.description"></div>
        </div>
        <div class="card-footer">
            详情
            <van-icon name="arrow" />
        </div>
    </div>
</template>

<script>
export default {
    props: ['app']
}
</script>

<style lang="scss" scoped>

.card--container {
    min-height: 96px;
    padding-bottom: 6px;
    background-color: #fff;
    border-radius: 5px;

    .card-header {
        padding: 3px 15px;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        

        &--content {
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            align-items: center;
            font-size: 17px;
            text-align: left;
            
            img {
                margin-right: 4px;
                width: 44px;
                height: 44px;
            }
        }
    }

    .card-body {
        position: relative;
        padding: 15px 15px 6px;
        min-height: 44px;
        font-size: 15px;
        color: #333;
    }

    .card-footer {
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        -webkit-align-items: center;
        align-items: center;
        padding: 0 15px;
        font-size: 14px;
        color: #888;

        & > * {
            margin-left: 3px;
        }
    }
}

</style>


